"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var socialBaseTheme = function (_a) {
    var _b;
    var MAX_S = _a.MAX_S;
    return ({
        socialSharingItem: {
            "&.email": {
                backgroundColor: "rgb(127,127,127)",
                borderRadius: "50%",
                height: "2rem",
                width: "2rem",
                verticalAlign: "middle",
                justifyContent: "center",
                alignItems: "center"
            }
        },
        socialSharing: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginTop: "0.5rem",
            "& button": {
                display: "flex"
            }
        },
        socialSharingIcon: {
            fontSize: "2rem",
            "&.email": {
                fontSize: "1.5rem"
            }
        },
        print: {
            '& ~ $divider': {
                width: '100%'
            },
            order: 1,
        },
        email: {
            '& ~ $divider': {
                width: '100%'
            },
            order: 2,
            color: "white",
            fontSize: "1.5rem"
        },
        clipboard: {
            '& ~ $divider': {
                width: '100%'
            },
            order: 3,
        },
        divider: (_b = {
                width: '100%'
            },
            _b[MAX_S] = {
                display: "none",
            },
            _b.order = 4,
            _b),
        facebook: {
            order: 5,
            color: "rgb(59, 89, 152)"
        },
        linkedin: {
            order: 6,
            color: "rgb(0, 127, 177)"
        },
        twitter: {
            order: 7,
            color: "rgb(0, 172, 237)"
        },
        reddit: {
            order: 8,
            color: "rgb(255, 69, 0)"
        }
    });
};
exports.default = socialBaseTheme;
//# sourceMappingURL=social.js.map